module.exports = __webpack_public_path__ + "img/Skyler.0558d6f0.png";